/* eslint-disable */
import { connect, useDispatch } from 'react-redux';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Switch } from '@mui/material';
import { cloneDeep } from 'lodash';
import { ListTable } from '../../../../Components/ListTable';
// import Calender from '../../../../Components/Forms/Payment Settlements/Calender/Calender';
import styles from './SkuStock.module.scss';
import analyticsAction from '../../../../Actions/analytics.actions';
import {
	addCommas,
	classes,
	convertToHigherUnit,
	getMonetaryUnit,
	handleExcelDownload,
	useQuery,
} from '../../../../Helpers';
import drawerActions from '@/Actions/drawer.actions';
import StockHistoryDrawer from '@/Components/Drawers/StockHistoryDrawer/StockHistoryDrawer';
import { useAuth } from '@/Components/Auth/Login/auth';
import { formActions } from '@/Actions';
import { notificationServices } from '@/Services';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import BaseDrawer from '@/Components/Drawers/BaseDrawer/BaseDrawer';
import useFeatureFlags from '@/Helpers/useFeatureFlags';
// import { isEmpty } from '../../../../Helpers/utils';
// import ImageModal from '../../../../Components/Modals/ImageModal/ImageModal';

// // Pack drawer table columns
// const PACK_TABLE_COLUMNS = [
// 	{
// 		title: 'Pack Size',
// 		config: {
// 			type: 'DATA',
// 		},
// 	},
// 	{
// 		title: 'Available Stock',
// 		config: {
// 			type: 'DATA',
// 		},
// 	},
// ];

// const PACK_ACTION_COLUMNS = [
// 	{
// 		title: 'Action',
// 		config: {
// 			type: 'DATA',
// 		},
// 	},
// ];

// const PACK_COLMAP = {
// 	'Pack Size': 'packSize',
// 	'Available Stock': 'availableStock',
// 	Action: 'id',
// };

const TABLE_COLUMNS = [
	{
		title: 'UY Sku ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SKU',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Inventory Unit',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SKU Type',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'Sales Menu',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Current Stock',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Stock worth',
		config: {
			type: 'DATA',
			sortable: true,
		},
	},
	{
		title: 'Inventory Par Level',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Required Stock',
		config: {
			type: 'DATA',
		},
	},
];

const PROCESS_SPECIAL_COLUMNS = [
	{
		title: 'Current Stock',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Stock worth',
		config: {
			type: 'DATA',
		},
	},
];

const ACTION_COLUMNS = [];

const COLMAP = {
	'UY Sku ID': 'id',
	SKU: 'skuName',
	'Inventory Unit': 'unit',
	Category: 'categoryName',
	'Sub Category': 'subCategoryName',
	'SKU Type': 'skuType',
	'Sales Menu': 'id',
	'Current Stock': 'currentStock',
	'Stock worth': 'currentStock',
	'Inventory Par Level': 'threshold',
	'Required Stock': 'stockRequired',
};

const SkuStockReport = (props) => {
	const {
		currentStockData,
		search,
		skuType,
		stockDeficit,
		selectedStore,
		toggleStockHistoryDrawer,
		type,
		PROCESS_TYPE_FILTER,
		process,
		assetId,
		assetName,
	} = props;
	const { appConfig = {}, userConfig = {} } = useAuth();
	const { measurement } = appConfig?.configs ?? {};
	const { level } = userConfig?.userDetails ?? {};
	const queryParams = useQuery();
	const [sortType, setSortType] = useState('asc');
	const sortTypeParam = queryParams?.get('sortType');
	const [activeSku, setActiveSku] = useState({});
	const dispatch = useDispatch();

	const { CAN_ORDER_IN_PACKS } = useFeatureFlags();
	// Pack drawer state
	const [packDrawerOpen, setPackDrawerOpen] = useState(false);
	const [selectedProductForPacks, setSelectedProductForPacks] =
		useState(null);
	const [packData, setPackData] = useState({ packSizes: [] });
	const [packDataLoading, setPackDataLoading] = useState(false);

	// Fetch pack sizes from API
	const fetchPackSizes = useCallback(async (variantId) => {
		setPackDataLoading(true);
		try {
			const response =
				await inventoryAnalyticsServices.fetchAvailablePackSizes({
					data: {
						childVariantId: variantId,
						storeId: selectedStore,
					},
				});
			if (response?.statusCode === 200) {
				setPackData({
					packSizes: response?.data?.packSizes || [],
				});
			} else {
				setPackData({ packSizes: [] });
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message || 'Failed to fetch pack sizes',
				});
			}
		} catch (error) {
			setPackData({ packSizes: [] });
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message || 'Failed to fetch pack sizes',
			});
		} finally {
			setPackDataLoading(false);
		}
	}, []);

	// Handler to open pack drawer
	const handlePacksDrawer = (item, stock) => {
		setSelectedProductForPacks({
			...item,
			variantName: stock?.variantName,
			variantId: stock?.variantId,
			categoryName: item?.categoryName || 'Cookies',
			skuId: item?.id || '12345',
			unit: item?.unit || 'Count',
		});
		setPackDrawerOpen(true);
		// Fetch pack sizes when drawer opens
		fetchPackSizes(stock?.variantId);
	};

	// Handler to close pack drawer
	const handleClosePackDrawer = () => {
		setPackDrawerOpen(false);
		setSelectedProductForPacks(null);
		setPackData({ packSizes: [] });
	};

	// Pack table trail handler
	const handlePackTrail = (packItem) => {
		// Open StockHistoryDrawer with type PACKS
		toggleStockHistoryDrawer(true, {
			type: 'PACKS',
			selectedStore,
			showQRTab: false,
			currentStock: `${packItem?.availableStock ?? 0} ${packItem?.unit ?? 'units'
				}`,
			packDetails: {
				packId: packItem?.id,
				packSize: packItem?.packSize,
				availableStock: packItem?.availableStock,
				unit: packItem?.unit,
			},
			itemDetails: {
				...selectedProductForPacks,
				id:
					selectedProductForPacks?.id ||
					selectedProductForPacks?.skuId,
			},
			heading: `Pack Trail of ${selectedProductForPacks?.skuName || 'Product'
				} - ${packItem?.packSize}`,
		});
	};

	// // Pack table special items
	// const PACK_SPECIAL_ITEMS = {
	// 	'Available Stock': (id) => {
	// 		const pack = DUMMY_PACK_DATA.packSizes.find((p) => p.id === id);
	// 		return (
	// 			<div className='flex items-center'>
	// 				<span>{pack?.availableStock} {pack?.unit}</span>
	// 			</div>
	// 		);
	// 	},
	// 	Action: (id) => {
	// 		return (
	// 			<div
	// 				onClick={() => handlePackTrail({ id })}
	// 				className='text-sm underline text-uy-color font-semibold cursor-pointer'
	// 			>
	// 				Trail
	// 			</div>
	// 		);
	// 	},
	// };

	useEffect(() => {
		if (currentStockData?.length > 0) {
			setActiveSku((prev) => {
				if (Object.keys(prev).length > 0) return prev;
				const newActiveSku = {};
				currentStockData?.forEach((ele) => {
					ele?.currentStock?.forEach((stock) => {
						newActiveSku[ele?.id] = {
							...(newActiveSku[ele?.id] || {}),
							[stock?.variantId]: stock?.active,
						};
					});
				});
				return newActiveSku;
			});
		}
	}, [currentStockData]);

	const processIdMap = useMemo(() => {
		const processMap = {};
		if (Array.isArray(process)) {
			process.forEach((ele) => {
				if (ele?.id) {
					processMap[ele.id] = ele?.data?.heading || '';
				}
			});
		}
		return processMap;
	}, [process]);

	const handleAllItemsTrail = () => {
		toggleStockHistoryDrawer(true, {
			type,
			allVariants: true,
			lastUpdatedAt: currentStockData?.[0]?.lastUpdatedAt,
			processId:
				type === 'PROCESS_REPORT'
					? PROCESS_TYPE_FILTER?.selectedProcessTypes?.[0]
					: null,
			heading: `Stock Trail ${assetName ? `of [${assetName}]` : ''} ${type === 'PROCESS_REPORT'
				? ` of all items on process [${processIdMap[
				PROCESS_TYPE_FILTER?.selectedProcessTypes?.[0]
				]
				}]`
				: ''
				}
				`,
		});
		notificationServices.generateNotification({
			type: 'wave',
			message: 'Please update date range according to your needs',
		});
	};

	const handleActiveSkuChange = async (id, variantId, e) => {
		const checked = e.target.checked;

		setActiveSku((prev) => ({
			...prev,
			[id]: {
				...(prev[id] || {}),
				[variantId]: checked,
			},
		}));

		try {
			const response =
				await inventoryAnalyticsServices.stockHistoryActivity({
					data: {
						skuId: id,
						variantId,
						storeId: selectedStore,
						active: checked,
					},
				});

			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			} else {
				throw new Error(response?.message);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message || 'Failed to update',
			});

			setActiveSku((prev) => ({
				...prev,
				[id]: {
					...(prev[id] || {}),
					[variantId]: !checked,
				},
			}));
		}
	};

	// trail drawer function
	const handleTrailDrawer = async (item, stock, NumberQty, qtyUnit) => {
		try {
			let showQRTab = false;
			if (type !== 'PROCESS_REPORT' && !assetId) {
				const response = await inventoryAnalyticsServices.isQRTab({
					data: {
						storeId: selectedStore,
						productId: item?.id,
						variantId: stock?.variantId,
					},
				});
				if (response?.statusCode === 200) {
					showQRTab = response?.data;
				}
			}
			toggleStockHistoryDrawer(true, {
				type,
				selectedStore,
				assetId,
				showQRTab,
				currentStock: `${NumberQty > 0 ? NumberQty : 0} ${qtyUnit}`,
				processId:
					type === 'PROCESS_REPORT'
						? PROCESS_TYPE_FILTER?.selectedProcessTypes?.[0]
						: null,
				itemDetails: {
					...item,
					variantId: stock?.variantId,
					variantName: stock?.variantName,
				},
				heading: `Stock Trail of ${item?.skuName}${stock?.variantName ? `(${stock?.variantName})` : ''
					}${assetName ? ` of [${assetName}]` : ''}${type === 'PROCESS_REPORT'
						? ` on process [${processIdMap[
						PROCESS_TYPE_FILTER
							?.selectedProcessTypes?.[0]
						]
						}]`
						: ''
					}
				`,
			});
		} catch (error) {
			console.log(error);
		}
	};

	const SPECIAL_ITEMS = {
		'Sales Menu': (id) => {
			const item = currentStockData?.find((ele) => {
				return ele?.id === id;
			});

			// Only show Active switch for level 3 users
			if (level < 2) {
				return item?.currentStock?.map((stock) => {
					return (
						<div className={styles['multi-items']}>
							{/* <p>{stock?.variantName}:</p> */}
							<p>
								{activeSku?.[item?.id]?.[stock?.variantId]
									? 'Yes'
									: 'No'}
							</p>
						</div>
					);
				});
			}

			return item?.currentStock?.map((stock) => {
				return (
					<Switch
						size='small'
						color='primary'
						checked={Boolean(
							activeSku?.[item?.id]?.[stock?.variantId]
						)}
						onChange={(e) =>
							handleActiveSkuChange(item?.id, stock?.variantId, e)
						}
					/>
				);
			});
		},
		'Current Stock': (id) => {
			const item = currentStockData?.find((ele) => {
				return ele?.id === id;
			});
			return item?.currentStock?.map((stock, i) => {
				const stockInNum =
					stock?.qty?.split(' ')[0] !== '-'
						? Number(stock?.qty?.split(' ')[0])
						: '';
				const thresholdInNum =
					item?.threshold[i]?.qty?.split(' ')[0] !== '-'
						? Number(item?.threshold[i]?.qty?.split(' ')[0])
						: '';
				const isLessThan = stockInNum < thresholdInNum;
				const qtyValue = stock?.qty?.split(' ')?.[0];
				const qtyUnit = stock?.qty?.split(' ')?.[1];
				// eslint-disable-next-line no-restricted-globals
				const NumberQty = !isNaN(Number(qtyValue))
					? Number(qtyValue)
					: 0;
				return (
					<div className='flex gap-1 items-center'>
						{/* {isLessThan && (
							<p className={styles['summary-text']}>
								Current Stock is less than Threshold
							</p>
						)} */}
						<div
							className={classes(
								styles['multi-items'],
								isLessThan ? styles.less : ''
							)}
						>
							{/* {isLessThan && (
								<p></p>
							)} */}
							<p>{stock?.variantName}:</p>
							<p>
								{NumberQty < 0 ? 0 : NumberQty}
								{qtyUnit}
							</p>
						</div>
						<div className='flex flex-col items-center justify-center'>
							<div
								onClick={() =>
									handleTrailDrawer(
										item,
										stock,
										NumberQty,
										qtyUnit
									)
								}
								className='text-sm underline text-uy-color font-semibold cursor-pointer'
							>
								Trail
							</div>
							{CAN_ORDER_IN_PACKS && !assetId && (
								<div
									onClick={() =>
										handlePacksDrawer(item, stock)
									}
									className='text-sm underline text-amber-600 font-semibold pr-4 cursor-pointer'
								>
									Packs
								</div>
							)}
						</div>
					</div>
				);
			});
		},
		'Stock worth': (id) => {
			const item = currentStockData?.find((ele) => {
				return ele?.id === id;
			});
			return item?.currentStock?.map((stock) => {
				const perUnit = convertToHigherUnit(item?.unit)?.unit;
				const moneyUnit = getMonetaryUnit(measurement);
				return (
					<div className='flex gap-1 items-center relative'>
						<div className={classes(styles['multi-items'])}>
							<div className='flex flex-col items-start'>
								<p className='text-xs text-blue-600'>
									{moneyUnit}
									{stock?.rate} per {perUnit}
								</p>
								<p>{stock?.variantName}:</p>
							</div>
							<p>
								{addCommas(stock?.stockAmount, measurement) ??
									'-'}
							</p>
						</div>
					</div>
				);
			});
		},
		'Inventory Par Level': (id) => {
			const item = currentStockData?.find((ele) => {
				return ele?.id === id;
			});
			return item?.threshold?.map((stock, i) => {
				const stockInNum =
					item?.currentStock[i]?.qty?.split(' ')[0] !== '-'
						? Number(item?.currentStock[i]?.qty?.split(' ')[0])
						: '';
				const thresholdInNum =
					stock?.qty?.split(' ')[0] !== '-'
						? Number(stock?.qty?.split(' ')[0])
						: '';
				const isLessThan = stockInNum < thresholdInNum;
				return (
					<div className={styles['items-container']}>
						{/* {isLessThan && (
							<p className={styles['summary-text']}>
								Threshold is more than Current Stock
							</p>
						)} */}
						<div
							className={classes(
								styles['multi-items'],
								isLessThan ? styles.less : ''
							)}
						>
							<p>{stock?.variantName}:</p>
							<p>{stock?.qty}</p>
						</div>
					</div>
				);
			});
		},
		'Required Stock': (id) => {
			const item = currentStockData?.find((ele) => {
				return ele?.id === id;
			});
			return item?.stockRequired?.map((stock) => {
				return (
					<div className={styles['items-container']}>
						<div className={styles['multi-items']}>
							<p>{stock?.variantName}:</p>
							<p>{stock?.qty}</p>
						</div>
					</div>
				);
			});
		},
	};

	const handleSort = (sort, col) => {
		let sortData = [...currentStockData];
		if (sort === 'asc') {
			sortData = sortData.sort((a, b) => {
				const aQty =
					a?.currentStock
						?.map((stock) => {
							return parseFloat(stock?.stockAmount) || 0;
						})
						?.reduce((acc, curr) => acc + curr, 0) || 0;

				const bQty =
					b?.currentStock
						?.map((stock) => {
							return parseFloat(stock?.stockAmount) || 0;
						})
						?.reduce((acc, curr) => acc + curr, 0) || 0;

				return aQty - bQty;
			});
			setSortType('desc');
		} else {
			sortData = sortData.sort((a, b) => {
				const aQty =
					a?.currentStock
						?.map((stock) => {
							return parseFloat(stock?.stockAmount) || 0;
						})
						?.reduce((acc, curr) => acc + curr, 0) || 0;

				const bQty =
					b?.currentStock
						?.map((stock) => {
							return parseFloat(stock?.stockAmount) || 0;
						})
						?.reduce((acc, curr) => acc + curr, 0) || 0;

				return bQty - aQty;
			});
			setSortType('asc');
		}
		dispatch(
			analyticsAction.resetInventoryAnalyticsState({
				entity: 'INVENTORY_ANALYTICS',
				method: 'SKU_STOCK',
				data: sortData,
			})
		);
	};

	useEffect(() => {
		if (sortTypeParam && currentStockData?.length > 0) {
			handleSort(sortTypeParam, '');
		}
	}, [sortTypeParam, currentStockData]);

	return (
		<div className={`${styles.root}`}>
			<StockHistoryDrawer />
			{/* Pack Details Drawer */}
			<BaseDrawer
				open={packDrawerOpen}
				onClose={handleClosePackDrawer}
				header='Product Details'
				size='xs'
			>
				{selectedProductForPacks && (
					<div className='flex flex-col'>
						{/* Product Header Section */}
						<div className='flex items-center gap-4 py-6 border-b border-gray-200'>
							<div className='w-14 h-14 bg-gray-200 rounded-lg flex items-center justify-center overflow-hidden flex-shrink-0'>
								<img
									src={
										selectedProductForPacks?.productImageUrl ||
										'https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=80&h=80&fit=crop'
									}
									alt={
										selectedProductForPacks?.skuName ||
										'Product'
									}
									className='w-full h-full object-cover rounded-lg'
									onError={(e) => {
										e.target.src =
											'https://via.placeholder.com/56?text=SKU';
									}}
								/>
							</div>
							<h3 className='text-base font-semibold text-gray-900'>
								{selectedProductForPacks?.skuName || '-'} (
								{selectedProductForPacks?.variantName || '-'})
							</h3>
						</div>

						{/* Basic Information Section */}
						<div className='py-5 border-b border-gray-200'>
							<h4 className='text-sm font-semibold text-gray-900 mb-4'>
								Basic Information
							</h4>
							<div className='flex justify-between'>
								<div>
									<p className='text-xs text-gray-500 mb-1'>
										Category
									</p>
									<p className='text-sm font-medium text-gray-900'>
										{selectedProductForPacks?.categoryName ||
											'-'}
									</p>
								</div>
								<div>
									<p className='text-xs text-gray-500 mb-1'>
										SKU ID
									</p>
									<p className='text-sm font-medium text-gray-900'>
										{selectedProductForPacks?.skuId || '-'}
									</p>
								</div>
								<div>
									<p className='text-xs text-gray-500 mb-1'>
										Unit
									</p>
									<p className='text-sm font-medium text-gray-900'>
										{selectedProductForPacks?.unit || '-'}
									</p>
								</div>
							</div>
						</div>

						{/* Pack Sizes & Inventory Section */}
						<div className='py-5'>
							<h4 className='text-sm font-semibold text-gray-900 mb-4'>
								Pack Sizes & Inventory
							</h4>
							<div className='border border-gray-200 rounded-lg overflow-hidden'>
								{/* Table Header */}
								<div className='flex bg-gray-50 border-b border-gray-200'>
									<div className='flex-1 px-4 py-3 text-xs font-medium text-gray-600'>
										Pack Size
									</div>
									<div className='flex-1 px-4 py-3 text-xs font-medium text-gray-600'>
										Available Stock
									</div>
									<div className='w-16 px-4 py-3'></div>
								</div>
								{/* Table Rows */}
								{packDataLoading ? (
									<div className='flex items-center justify-center py-8'>
										<span className='text-sm text-gray-500'>
											Loading pack sizes...
										</span>
									</div>
								) : packData.packSizes.length === 0 ? (
									<div className='flex items-center justify-center py-8'>
										<span className='text-sm text-gray-500'>
											No pack sizes available
										</span>
									</div>
								) : (
									packData.packSizes.map((pack, index) => (
										<div
											key={pack.id}
											className={`flex items-center ${index !==
												packData.packSizes.length - 1
												? 'border-b border-gray-200'
												: ''
												}`}
										>
											<div className='flex-1 px-4 py-4 text-sm text-gray-900'>
												{pack.packagingVariantName}{' '}
												(Pack of {pack.packSize})
											</div>
											<div className='flex-1 px-4 py-4 text-sm text-gray-900'>
												{pack.availableStock}
											</div>
											{/* <div className='w-16 px-4 py-4'>
												<span
													onClick={() => handlePackTrail(pack)}
													className='text-sm text-orange-500 font-medium cursor-pointer hover:text-orange-600'
												>
													Trail
												</span>
											</div> */}
										</div>
									))
								)}
							</div>
						</div>
					</div>
				)}
			</BaseDrawer>
			<ListTable
				renderBtns={() => {
					if (
						currentStockData?.length === 0 ||
						type !== 'PROCESS_REPORT' ||
						!PROCESS_TYPE_FILTER?.selectedProcessTypes?.[0]
					)
						return <></>;
					return (
						<div
							className='bg-uy-color text-white px-4 py-2 rounded-md font-semibold cursor-pointer hover:bg-opacity-90 transition-all flex items-center justify-center mr-4'
							onClick={handleAllItemsTrail}
						>
							<span>All Items Trail</span>
						</div>
					);
				}}
				fixedHeaderTop={0}
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={currentStockData
					?.filter((SKU) => {
						if (skuType === 'ALL' || !skuType) return true;
						return SKU.skuType
							.toLowerCase()
							.trim()
							?.includes(skuType.toLowerCase().trim());
					})
					?.filter((ele) => {
						if (search.trim())
							return ele?.skuName
								?.toLowerCase()
								.trim()
								?.includes(search?.toLowerCase()?.trim());
						return true;
					})
					.map((ele) => {
						if (!stockDeficit) return ele;
						const isLessThanStock = ele?.currentStock?.map(
							(stock, i) => {
								const stockInNum =
									stock?.qty?.split(' ')[0] !== '-'
										? Number(stock?.qty?.split(' ')[0])
										: '';
								const thresholdInNum =
									ele?.threshold[i]?.qty?.split(' ')[0] !==
										'-'
										? Number(
											ele?.threshold[i]?.qty?.split(
												' '
											)[0]
										)
										: '';
								return stockInNum < thresholdInNum;
							}
						);
						return isLessThanStock?.includes(true) ? ele : null;
					})
					.filter(Boolean)}
				special={SPECIAL_ITEMS}
				actions={
					type === 'PROCESS_REPORT'
						? [...PROCESS_SPECIAL_COLUMNS, ...ACTION_COLUMNS]
						: [...SPECIAL_COLUMNS, ...ACTION_COLUMNS]
				}
				allowExport={false}
				sortType={sortType}
				handleSort={handleSort}
			/>
		</div>
	);
};

const mapStateToProps = (state) => {
	// const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	const { PROCESS_TYPE_FILTER } = state?.analytics;
	const process = state?.form?.PROCESS_TYPES?.data?.LIST;
	const data = state.analytics.INVENTORY_ANALYTICS.SKU_STOCK;
	return {
		// dateRangeFilter,
		currentStockData: Array.isArray(data) ? data : Array?.from(data),
		PROCESS_TYPE_FILTER,
		process,
	};
};

const mapDispatchToProps = {
	fetchData: analyticsAction.fetchDataRange,
	fetchProcessList: formActions.gateway,
	toggleStockHistoryDrawer: drawerActions.toggleStockHistoryDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(SkuStockReport);
